import tailwindConfig from '../../tailwind.config';

const tailwindColours = tailwindConfig.theme.extend.colors;

const graphColourMap = {
  'Eligible and not claiming': tailwindColours.primary.DEFAULT,
  eligible: tailwindColours.primary.DEFAULT,
  'Potentially eligible': tailwindColours.primary.DEFAULT,
  Claiming: tailwindColours.pipblue.DEFAULT,
  claiming: tailwindColours.pipblue.DEFAULT,
  'May need support': tailwindColours.primary.DEFAULT,
  'In receipt of support': tailwindColours.pipblue.DEFAULT,
};
const segmentColours = [
  tailwindConfig.theme.extend.colors.pieChart.slice1,
  tailwindConfig.theme.extend.colors.pieChart.slice2,
  tailwindConfig.theme.extend.colors.pieChart.slice3,
  tailwindConfig.theme.extend.colors.pieChart.slice4,
  tailwindConfig.theme.extend.colors.pieChart.slice5,
  tailwindConfig.theme.extend.colors.pieChart.slice6,
  tailwindConfig.theme.extend.colors.pieChart.slice7,
];
const pieChartLabels = {
  fontSize: 16,
  fontFamily: tailwindConfig.theme.extend.fontFamily.nunito[0],
  fill: tailwindColours.piptext.chart,
  fontWeight: '600',
};

export { graphColourMap, segmentColours, pieChartLabels };
